import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { startRegisterSearchInfo } from "../../app/actions/searchInfoActions";
import { setPreviousSearchParams } from "../../app/actions/searchHistoryActions";
import { dispatchModulePaginatedSearch } from "../../app/helpers/moduleSearch.helper";

const FILTER_SERIES = "catalogserie_id";
const FILTER_SOPHISTICATIONS = "catalogsophistication_id"
const FILTER_MAGNITUDES = "catalogmagnitude_id"
const FILTER_SIZES = "catalogsize_id"
const FILTER_TYPOLOGIES = "catalogtypology_id"
const FILTER_PRICERANGES = "catalogpricerange_id"
const FILTER_PROBLEMS = "catalogproblem_ids"
const FILTER_PROBLEM = "catalogproblem_id"

const FILTER_COMPLEXITIES = "catalogcomplexity_id";
const FILTER_MEASURE = "catalogmeasure_id";
const FILTER_STRATEGY = "catalogstrategy_id";
const FILTER_AMPLITUDE = "catalogamplitude_id";
const FILTER_MITIGATION = "catalogmitigation_id";

const CheckListOptionsCatalogState = ({
  dataList,
  title,
  keyCatalog,
  searchTextState,
  catalogsToFilter,
  setCatalogsToFilter,
  itemsPerPage,
  setItemsPerPage,
  moduleSelected,
  catalogCiiuLevel1Selected,
  indicatorsToFilter,
  setIndicatorsToFilter,
  groupVisionSelected
}) => {
  const dispatch = useDispatch();

  const [checkboxes, setCheckboxes] = useState(dataList);
  const [checkboxesHist, setCheckboxesHist] = useState([]);

  const { user } = useSelector((state) => state.auth);

  useEffect(() => {

    const indexForConsider = catalogsToFilter.findIndex((item) => item.hasOwnProperty(keyCatalog));
    if (catalogsToFilter && catalogsToFilter.length > 0 && indexForConsider !== -1) {

      if (dataList && dataList.length > 0) {

        let checkboxesHistChecked = {};
        if (checkboxesHist && checkboxesHist.length > 0) {

          checkboxesHistChecked = checkboxesHist.find((itemHist) => itemHist.isChecked);

          if (checkboxesHistChecked && Object.keys(checkboxesHistChecked).length > 0) {

            let dataListHist = [...dataList];

            let dataListHistChecked = dataListHist.find((itemDataListChecked) => itemDataListChecked.id === checkboxesHistChecked.id);

            if (dataListHistChecked && Object.keys(dataListHistChecked).length > 0) {

              dataListHistChecked.isChecked = true;

              setCheckboxes([dataListHistChecked]);
            } else {

            }
          } else {

          }
        } else {

          setCheckboxes(dataList);
        }
      } else {

      }
    } else {

      setCheckboxes(dataList);
    }

  }, [dataList, catalogsToFilter])

  const setCatalogToFilter = (id, dataListLocal) => {

    let catalogsToFilterList = [];
    catalogsToFilterList = [...catalogsToFilter];

    let catalogOptionToFilterObjet = {};

    switch (keyCatalog) {
      case FILTER_SERIES:
        catalogOptionToFilterObjet = {
          catalogserie_id: id,
        };
        break;
      case FILTER_SOPHISTICATIONS:
        catalogOptionToFilterObjet = {
          catalogsophistication_id: id,
        };
        break;
      case FILTER_MAGNITUDES:
        catalogOptionToFilterObjet = {
          catalogmagnitude_id: id,
        };
        break;
      case FILTER_SIZES:
        catalogOptionToFilterObjet = {
          catalogsize_id: id,
        };
        break;
      case FILTER_TYPOLOGIES:
        catalogOptionToFilterObjet = {
          catalogtypology_id: id,
        };
        break;
      case FILTER_PRICERANGES:
        catalogOptionToFilterObjet = {
          catalogpricerange_id: id,
        };
        break;
      case FILTER_PROBLEMS:
        catalogOptionToFilterObjet = {

          catalogproblem_ids: id,
        };
        break;
      case FILTER_PROBLEM:
        catalogOptionToFilterObjet = {
          catalogproblem_id: id,
        };
        break;
      case FILTER_MEASURE:
        catalogOptionToFilterObjet = {

          catalogmeasure_id: id,
        };
        break;

      case FILTER_COMPLEXITIES:
        catalogOptionToFilterObjet = {

          catalogcomplexity_id: id,
        };
        break;

      case FILTER_STRATEGY:
        catalogOptionToFilterObjet = {

          catalogstrategy_id: id,
        };
        break;

      case FILTER_AMPLITUDE:
        catalogOptionToFilterObjet = {

          catalogamplitude_id: id,
        };
        break;

      case FILTER_MITIGATION:
        catalogOptionToFilterObjet = {

          catalogmitigation_id: id,
        };
        break;

      /*
    case FILTER_WORRIES:
      catalogOptionToFilterObjet = {
        
        worry_ids: id,
      };
      break;
      */

      /*
    case FILTER_TOPICS:
      catalogOptionToFilterObjet = {
        
        topics_ids: id,
      };
      break;
      */

      /*
    case FILTER_THEMES:
      catalogOptionToFilterObjet = {
        
        themes_ids: id,
      };
      break;
      */

      default:
        catalogOptionToFilterObjet = {
          [keyCatalog]: id,
        };
        break;
    }

    const catalog_id_object =
      catalogsToFilterList &&
      catalogsToFilterList.length > 0 &&
      catalogsToFilterList.find((element) =>
        element.hasOwnProperty(keyCatalog)
      );

    if (!catalog_id_object) {

      setCheckboxesHist(dataListLocal);

      catalogsToFilterList.push(catalogOptionToFilterObjet);
      setCatalogsToFilter(catalogsToFilterList);

      /*******> SEARCH_INFO <*******/

      const searchInfo = {
        text_search: searchTextState,
        indicators: indicatorsToFilter,
        filters: catalogsToFilterList,

        catalogmodule_id: moduleSelected.id,
        user_id: user.user_id,

        deleted: false
      }

      dispatch(startRegisterSearchInfo(searchInfo));

      //JT PAGE no tenia size
      dispatch(setPreviousSearchParams({
        searchText: searchTextState,
        page: 0,
        size: itemsPerPage,
        catalogsToFilter: catalogsToFilterList,
        indicatorsToFilter: indicatorsToFilter,
        catalogModule: moduleSelected || {},
        catalogCiiuLevel1: catalogCiiuLevel1Selected || {},
        groupVision: groupVisionSelected || {}
      }));

      // Preparas los parámetros
      const searchParams = {
        searchText: searchTextState,
        moduleKey: moduleSelected?.key,
        page: 0,
        itemsPerPage: itemsPerPage,
        catalogsToFilter: catalogsToFilterList,
        indicatorsToFilter: indicatorsToFilter,
        codeCiiuLevel1: catalogCiiuLevel1Selected?.code || null
      };

      // Ejecutas el helper genérico
      dispatchModulePaginatedSearch(dispatch, searchParams);
    }
  };

  const handleChangeCheckbox = (event, id) => {

    let dataListLocal = [...dataList];

    dataListLocal = checkboxes.map((checkbox) =>
      checkbox.id === id ? { ...checkbox, isChecked: true } : checkbox
    )

    setCheckboxes(checkboxes.map((checkbox) =>
      checkbox.id === id ? { ...checkbox, isChecked: true } : checkbox
    ));

    setCatalogToFilter(id, dataListLocal);

  }

  return (
    <div>
      <div className="option-title">{/*title*/}</div>
      <ul className="toppings-list">
        {checkboxes.map(({ name, description, id, isChecked }, index) => {
          return (
            <li key={index}>
              <div className="toppings-list-item">
                <div className="left-section">
                  <input
                    type="checkbox"
                    id={`custom-checkbox-${index}`}
                    checked={isChecked}
                    name={description}
                    value={description}
                    onChange={(event) => handleChangeCheckbox(event, id)}
                  />
                  <label
                    htmlFor={`custom-checkbox-${index}`}
                    style={{ display: "inline" }}
                  >
                    {description}
                  </label>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CheckListOptionsCatalogState;